// extracted by mini-css-extract-plugin
export var contentarea = "ArticlePage-module--contentarea--0d265";
export var metawrapper = "ArticlePage-module--metawrapper--fda35";
export var relatedwrapper = "ArticlePage-module--relatedwrapper--52819";